/* eslint-disable no-nested-ternary */
import React, { useCallback, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../api/api";
import Style from "../../assets/css/main.module.css";
import calenderIcon from "../../assets/icons/calender.svg";
import caretDownIcon from "../../assets/icons/caret-down-dark.svg";
import { drawerAction, setChildId } from "../../store/features/deviceSlice";
import addChildrenSchema from "../../validation/membershipChildrenSchema";
import ErrorMessage from "../ui/ErrorMessage";

const initial = {
    name: "",
    date_of_birth: null,
    gender: "",
    class: "",
    school: "",
  };

export default function AddChildren({ item }) {
  const { childId } = useSelector((state) => state.deviceSlice);

  const [selectedChild, setselectedChild] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [addMode, setAddMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [children, setChildren] = useState([]);
  const [credentials, setCredentials] = useState(initial);
  const [errors, setErrors] = useState(null);
  const [childApiComplete, setChildApiComplete] = useState(false);

  const credentialHandler = (event) => {
    const { name, value } = event.target;
    setCredentials({ ...credentials, [name]: value });
  };

  const selectedDate = (name, value) => {
    setCredentials({ ...credentials, [name]: value });
  };

  const onchangeHandler = (event) => {
    const { value } = event.target;
    dispatch(setChildId(value));
  };

  useEffect(() => {
    if (+childId) {
      const selectedchild = children.filter(child => child.id === +childId) || null
      setselectedChild(selectedchild?.length ? selectedchild[0] : null)
    }
  }, [childId, children]);

  const fetch = useCallback(async () => {
    const res = await api.getChildren();
    if (res.status === 200) {
      const activeChildren = res.data.data.filter(
        (resData) => resData.status === 1
      );
      setChildren(activeChildren);
    }
    setChildApiComplete(true)
  }, []);

  const saveChildrenHandler = async () => {
    try {
      const result = addChildrenSchema.safeParse(credentials);
      if (result.success) {
        setErrors(null);
        setLoading(true);
        credentials.date_of_birth = new Date(credentials.date_of_birth)
          .toISOString()
          .slice(0, 10);
        const res = await api.addChildren(credentials);
        if (res.status === 201) {
          toast.success("Child added successfully");
          dispatch(setChildId(res.data.data.id));
          await fetch();
          setCredentials(initial);
          setAddMode(false);
        } else if (res.status === 422) {
          Object.values(res.data.data).forEach((error) => {
            toast.error(error[0]);
          });
        } else {
          toast.error("Server side error!Please try again later");
        }
        setLoading(false);
      } else {
        const errorsObject = result.error.errors.reduce((acc, error) => {
          const path = error.path.join(".");
          acc[path] = error.message;
          return acc;
        }, {});
        setErrors(errorsObject);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleCheckout = () => {
    if (!selectedChild) {
      toast.error("Please select a child to proceed");
    } else {
      navigate("/checkout", {
        state: { selectedItemsByTab: item, childInfo: selectedChild },
      });
      dispatch(drawerAction(false));
    }
  };
  useEffect(() => {
    fetch();
  }, [fetch]);

  if (!addMode) return <div className="w-100 h-100 px-2 px-md-4">
    <div className="profile-container overflow-y-scroll pt-2 pb-2">
      <div>
        <button
          type="button"
          onClick={() => setAddMode(!addMode)}
          className={`${Style.bg_primary} ${Style.fw_600} ${Style.fs_16} text-light border-0 rounded p-2 mt-2`}
        >
          + Add Child
        </button>
      </div>

      {(childApiComplete && children.length) ? <>
        <div className={`${Style.profile_input} position-relative py-3`}>
          <select
            name="children"
            className={`${childId ? "text-dark" : Style.color_gray_200} w-100 rounded`}
            onChange={onchangeHandler}
            value={childId}
          >
            <option value="" disabled={childId}>
              Select Child
            </option>
            {children.map((child) => (
              <option key={child.id} value={child.id}>
                {child.name}
              </option>
            ))}
          </select>
          <img
            src={caretDownIcon}
            alt="caret-down"
            className="position-absolute"
            style={{
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
            }}
          />
        </div>
        <div className="d-flex flex-column gap-2">
          <div
            className={`${Style.text_primary} ${Style.fw_600} ${Style.fs_20} py-3`}
          >
            {`${selectedChild?.name ? `${selectedChild?.name}'s info` : 'No child selected'}`}
          </div>
          {selectedChild?.name && <div className={Style.profile_input}>
            <p>Name: {selectedChild.name || ""}</p>
            <p>Date of Birth: {selectedChild.date_of_birth || ""}</p>
            <p>Gender: {selectedChild.gender || ""}</p>
            <p>Class: {selectedChild.class || ""}</p>
            <p>School: {selectedChild.school || ""}</p>
          </div>}
        </div>
      </> : <div />}
      {childApiComplete && !children.length && <p className="mt-2">No Child found. Please add child.</p>}

    </div>
    <div className="membership-bottom">
      <button
        type="button"
        disabled={!childId}
        onClick={handleCheckout}
        className={`${childId ? Style.bg_primary : "bg-secondary"} ${Style.fs_20} ${Style.fw_600} border-0 text-light w-100 cart-checkout-btn`}
      >
        Continue Buying Tickets
      </button>
    </div>
  </div>

  return (
    <div className="w-100 h-100 px-2 px-md-4">
      <div className="profile-container overflow-y-scroll pt-2 pb-2">

        <div className="d-flex flex-column gap-2">
          <div
            className={`${Style.text_primary} ${Style.fw_600} ${Style.fs_20} py-3`}
          >
            Provide your Child&apos;s Details
          </div>
          <div className={Style.profile_input}>
            <input
              type="text"
              name="name"
              className="w-100 rounded"
              placeholder="Enter Name"
              onChange={credentialHandler}
              required
            />
            {errors && errors.name && <ErrorMessage message={errors.name} />}
          </div>
          <div
            className={`${Style.profile_input} ${Style.children_custom_date} position-relative`}
          >
            <DatePicker
              className="w-100 rounded"
              selected={credentials.date_of_birth}
              onChange={(date) => selectedDate("date_of_birth", date)}
              dateFormat="dd/MM/yyyy"
              showYearDropdown
              scrollableYearDropdown
              yearDropdownItemNumber={100}
              showMonthDropdown
              maxDate={new Date()}
              placeholderText="Select Date of Birth"
            />
            <img
              src={calenderIcon}
              alt="caret-down"
              className="position-absolute"
              style={{
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
          </div>
          {errors && errors.date_of_birth && (
            <div>
              <ErrorMessage message={errors.date_of_birth} />
            </div>
          )}
          <div className={`${Style.profile_input} position-relative`}>
            <select
              name="gender"
              className={`${credentials?.gender ? "text-dark" : Style.color_gray_200} w-100 rounded`}
              onChange={credentialHandler}
              required
            >
              <option value="">Select Gender</option>
              <option value="male">Boy</option>
              <option value="female">Girl</option>
            </select>
            <img
              src={caretDownIcon}
              alt="caret-down"
              className="position-absolute"
              style={{
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
          </div>
          {errors && errors.gender && (
            <div>
              <ErrorMessage message={errors.gender} />
            </div>
          )}
          <div className={Style.profile_input}>
            <input
              type="text"
              name="class"
              className="w-100 rounded"
              placeholder="Enter Class"
              onChange={credentialHandler}
            />
            {errors && errors.class && (
              <ErrorMessage message={errors.class} />
            )}
          </div>
          <div className={Style.profile_input}>
            <input
              type="text"
              name="school"
              className="w-100 rounded"
              placeholder="Enter School Name"
              onChange={credentialHandler}
            />
            {errors && errors.school && (
              <ErrorMessage message={errors.school} />
            )}
          </div>
          <div className="pt-3">
            {!loading && (
              <>
                <button
                  type="button"
                  onClick={saveChildrenHandler}
                  className={`${Style.bg_primary} ${Style.fs_14} ${Style.fw_400} text-light rounded-1 p-1 border-0 w-100 save-btn`}
                >
                  Save Child
                </button>
                <button
                  type="button"
                  onClick={() => setAddMode(false)}
                  className={`${Style.bg_cancel} ${Style.fs_14} ${Style.fw_400} text-light rounded-1 p-1 border-0 w-100 save-btn mt-2`}
                >
                  Cancel
                </button>
              </>
            )}
            {loading && (
              <button
                disabled
                type="button"
                className={`${Style.bg_primary} ${Style.fs_14} ${Style.fw_400} text-light rounded-1 p-1 border-0 w-100 save-btn`}
              >
                <Spinner animation="border" role="status" size="sm">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
